export default "__VITE_ASSET__DdWsoPMK__"